import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "input", "results"]

  toggle(event) {
    event.preventDefault()
    this.dropdownTarget.classList.toggle("hidden")
    if (!this.dropdownTarget.classList.contains("hidden")) {
      this.inputTarget.focus()
      this.inputTarget.value = ""
      this._loadSuggestions()
    }
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
  }

  search() {
    const q = this.inputTarget.value.trim()
    if (q.length === 0) {
      this._loadSuggestions()
      return
    }
    if (q.length < 2) return

    clearTimeout(this._timer)
    this._timer = setTimeout(() => {
      fetch(`/conversations/suggestions?q=${encodeURIComponent(q)}`, {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
        .then(r => r.json())
        .then(data => this._renderResults(data.users || []))
        .catch(() => {})
    }, 300)
  }

  _renderResults(users) {
    if (users.length === 0) {
      this.resultsTarget.innerHTML = '<div class="new-convo__empty">Nenhum usuário encontrado</div>'
      return
    }

    const token = document.querySelector('meta[name="csrf-token"]').content
    this.resultsTarget.innerHTML = users.map(u => {
      const avatar = u.has_avatar
        ? `<img src="${u.avatar_url}" class="new-convo__avatar" width="32" height="32" />`
        : `<div class="new-convo__avatar new-convo__avatar--initials">${this._escapeHtml(u.initials)}</div>`
      return `
        <form action="/conversations" method="post" class="new-convo__form">
          <input type="hidden" name="authenticity_token" value="${token}">
          <input type="hidden" name="recipient_id" value="${u.id}">
          <button type="submit" class="new-convo__user">
            ${avatar}
            <div class="new-convo__info">
              <span class="new-convo__name">${this._escapeHtml(u.display_name)}</span>
              <span class="new-convo__username">@${this._escapeHtml(u.username)}</span>
            </div>
          </button>
        </form>
      `
    }).join("")
  }

  _loadSuggestions() {
    fetch("/conversations/suggestions", {
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(r => r.json())
      .then(data => {
        if (this.inputTarget.value.trim() === "") {
          this._renderResults(data.users || [])
        }
      })
      .catch(() => {})
  }

  _escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }

  // Close on click outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  connect() {
    this._outsideHandler = this.clickOutside.bind(this)
    document.addEventListener("click", this._outsideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideHandler)
  }
}
